import { render } from "./aboutContent.vue?vue&type=template&id=2f4ec184&scoped=true"
import script from "./aboutContent.vue?vue&type=script&lang=js"
export * from "./aboutContent.vue?vue&type=script&lang=js"

import "./aboutContent.vue?vue&type=style&index=0&id=2f4ec184&scoped=true&lang=less"

import exportComponent from "D:\\Git仓库\\象新力官网\\html_xxldx_xxlx_xxlg\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f4ec184"]])

export default __exports__